var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.show))?_c('div',{staticClass:"image-list"},_vm._l(((_vm.list)),function(item,index){return _c('mpx-image',{key:item.image,staticClass:"image",style:(_vm._f("transRpxStyle")([(item.style)])),attrs:{"src":(item.image),"mode":"widthFix","webp":""}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }